import { FC } from 'react';
import { GridSelect } from 'components/FeaturedSpreadsheet/components';
import { useFilteredAllocationMethods } from 'pages/ValuationsAllocation/hooks';
import AllocationMethodSelectorStyles from './AllocationMethodSelector.styles';

const AllocationMethodSelector: FC = props => {
  const filteredAllocationMethodsOptions = useFilteredAllocationMethods();

  const selectProps = {
    extraStyles: AllocationMethodSelectorStyles,
    menuPosition: 'absolute',
    objectOptions: { displayKey: 'name', valueKey: 'id' },
    options: filteredAllocationMethodsOptions,
  };

  return <GridSelect {...props} {...selectProps} />;
};

export default AllocationMethodSelector;
